/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { StoreActivationUpdate } from '../models/StoreActivationUpdate';
import type { StoreConfigUpdate } from '../models/StoreConfigUpdate';
import type { SuccessResponse_StoreConfigRead_ } from '../models/SuccessResponse_StoreConfigRead_';
import type { SuccessResponse_StoreListResponse_ } from '../models/SuccessResponse_StoreListResponse_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StoresService {
    /**
     * Update Store Endpoint
     * 编辑门店主数据、坐标、营业时间与经营档案。
     * @returns SuccessResponse_StoreConfigRead_ Successful Response
     * @throws ApiError
     */
    public static updateStoreEndpointApiV1StoresStoreIdPut({
        storeId,
        requestBody,
    }: {
        storeId: number,
        requestBody: StoreConfigUpdate,
    }): CancelablePromise<SuccessResponse_StoreConfigRead_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/stores/{store_id}',
            path: {
                'store_id': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Store Activation Endpoint
     * 停用或重新启用门店; 不删除或修补任何历史事实。
     * @returns SuccessResponse_StoreConfigRead_ Successful Response
     * @throws ApiError
     */
    public static setStoreActivationEndpointApiV1StoresStoreIdActivationPatch({
        storeId,
        requestBody,
    }: {
        storeId: number,
        requestBody: StoreActivationUpdate,
    }): CancelablePromise<SuccessResponse_StoreConfigRead_> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/stores/{store_id}/activation',
            path: {
                'store_id': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Stores Endpoint
     * GET /api/v1/stores — 列 actor 可见的门店清单.
     *
     * v0.13.0 F3 DISC-130 闭合: 把 Admin 创/编员工 + AreaManagerStoresSection
     * storeId 手填 InputNumber 升级为真实门店下拉.
     *
     * Query:
     * - ``include_inactive``: 是否含软下线店 (非 priv 角色静默忽略).
     * - ``store_id``: 单店过滤 (0=哨兵显式查询).
     *
     * Response (``StoreListResponse``):
     * - ``items``: ``list[StoreListItem]`` (含坐标、地址、营业时间与 active 状态).
     * - ``total``: 行数.
     *
     * 鉴权: ``Depends(get_actor)`` 任何已登录可读, 可见范围由应用层 enforce.
     * 限流: 同 actor 1 分钟 60 次.
     *
     * 错误码:
     * - 401 UNAUTHORIZED (未登录 / JWT 过期)
     * - 422 (Pydantic validation: ``store_id=-1`` 拒, ``include_inactive`` 非 bool 拒)
     * - 429 RATE_LIMITED
     * @returns SuccessResponse_StoreListResponse_ Successful Response
     * @throws ApiError
     */
    public static listStoresEndpointApiV1StoresGet({
        includeInactive = false,
        storeId,
        directOnly = false,
        brand = 'all',
    }: {
        /**
         * true=含 is_active=false 软下线店; 仅 super_admin/owner/hq_ops/finance 生效, 其他角色静默忽略 + structlog warn.
         */
        includeInactive?: boolean,
        /**
         * 单店过滤 (ge=0; 0=哨兵 HQ 显式查询, 默认不返 — super_admin 显式 ?store_id=0 才返). 不可见时返空 items 不 403 (防探测).
         */
        storeId?: (number | null),
        /**
         * true=仅返回在营直营门店; 用于总部只读业务范围选择
         */
        directOnly?: boolean,
        /**
         * 品牌过滤; all=不按品牌收窄
         */
        brand?: 'all' | 'yss' | 'qjx',
    }): CancelablePromise<SuccessResponse_StoreListResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/stores',
            query: {
                'include_inactive': includeInactive,
                'store_id': storeId,
                'direct_only': directOnly,
                'brand': brand,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
